import React from 'react';

interface SelectionControlsProps {
  selectedIds: string[];
  totalCount: number;
  onSelectAll: () => void;
  onClearSelection: () => void;
  className?: string;
}

const SelectionControls: React.FC<SelectionControlsProps> = ({
  selectedIds,
  totalCount,
  onSelectAll,
  onClearSelection,
  className = '',
}) => {
  if (selectedIds.length === 0) return null;

  return (
    <div className={`flex items-center justify-between p-3 bg-blue-50 border border-blue-200 rounded-md ${className}`}>
      <div className="flex items-center gap-4">
        <span className="font-medium text-blue-900">
          {selectedIds.length} objet{selectedIds.length > 1 ? 's' : ''} sélectionné{selectedIds.length > 1 ? 's' : ''}
        </span>
        {selectedIds.length < totalCount && (
          <button
            onClick={onSelectAll}
            className="text-sm text-blue-600 hover:underline focus:outline-none"
          >
            Tout sélectionner ({totalCount})
          </button>
        )}
      </div>
      <button
        onClick={onClearSelection}
        className="text-sm text-blue-600 hover:underline focus:outline-none"
      >
        Désélectionner tout
      </button>
    </div>
  );
};

export default SelectionControls;
